/* The newsletter submits through Shopify; this script adds visual effects only. */
if (!customElements.get('agrolix-premium-footer')) {
  customElements.define('agrolix-premium-footer', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.cleanup = new AbortController();
      this.effects = new Set();
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.classList.contains('pf--motion')) return;
      if (!this.reduced.matches) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('pf__revealed');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: .1 });
        this.querySelectorAll('.pf__brand,.pf__nav,.pf__contact-column,.pf__badge-wrap').forEach(node => this.observer.observe(node));
      }
      this.addEventListener('click', event => {
        const target = event.target.closest('.pf__social,.pf__button,a.pf__badge');
        if (!target || target.disabled || this.reduced.matches) return;
        const rect = target.getBoundingClientRect();
        const wave = document.createElement('span');
        wave.className = 'pf__click-wave';
        wave.setAttribute('aria-hidden','true');
        wave.style.left = `${event.detail ? event.clientX - rect.left : rect.width/2}px`;
        wave.style.top = `${event.detail ? event.clientY - rect.top : rect.height/2}px`;
        target.append(wave);
        const animation = wave.animate([
          { transform:'translate(-50%,-50%) scale(0)',opacity:.6 },
          { transform:`translate(-50%,-50%) scale(${Math.hypot(rect.width,rect.height)/20})`,opacity:0 }
        ], { duration:450,easing:'ease-out' });
        this.effects.add(animation);
        const finish = () => { wave.remove(); this.effects.delete(animation); };
        animation.finished.then(finish,finish);
      }, { signal:this.cleanup.signal });
    }
    disconnectedCallback() {
      this.cleanup?.abort();
      this.observer?.disconnect();
      this.effects?.forEach(effect => effect.cancel());
    }
  });
}
